<template>
    <!--
    Vue-router on multi page app and page reload
        ref: https://forum.vuejs.org/t/vue-router-on-multi-page-app-and-page-reload/48405
    -->
    <div id="app">
        <page-header :user="user"></page-header>
        <main role="role">
            <router-view :user="user" :is-phone="isPhone"></router-view>
        </main>
        <page-footer></page-footer>
        <b-dialog/>
    </div>
</template>

<script>
    import appMixin from '@/lib/AppBaseMixin.js';

    import PageHeader from '@/components/Elements/PageHeader.vue';
    import PageFooter from '@/components/Elements/PageFooter.vue';

    export default {
        name: 'App',
        mixins: [appMixin],
        components: {
            PageHeader,
            PageFooter,
        },
        data: function () {
            return {
                
            };
        },
        methods: {
            initData: function () {
            },
        },  // end of methods
        computed: {
        },
        mounted: function () {
            this.initData();
        },
        watch: {
        },
        created() {
        },
    }
</script>

<style>
    .lexprogress-wrapper {
        background-color: #F7F8FA;
        padding-bottom: 60px;
    }
    .search-content-wrapper{
        background-color: #fff;
        border-radius: 5px;
        margin-top: 130px;
        margin-bottom: 40px;
        padding: 60px;
    }
    html{
        background-color: #F7F8FA!important;
    }
</style>
